import { FaroErrorBoundary } from '@grafana/faro-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { faroEnabled, initFaro } from './shared/faro';

// Started before the first render, so a failure during startup is reported too.
initFaro();

// A crash mid-sale must not leave a blank screen on a till.
const crashFallback = (
  <div className="crashFallback">
    <h1>Something went wrong</h1>
    <p>The app hit an unexpected error. Reload to carry on.</p>
    <button type="button" onClick={() => window.location.reload()}>
      Reload
    </button>
  </div>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    {faroEnabled ? (
      <FaroErrorBoundary fallback={crashFallback}>
        <App />
      </FaroErrorBoundary>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
